import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const MASCOT = "https://customer-assets-jt897jd0.emergentagent.net/job_smoke-beach-drop/artifacts/g2ejgl6q_maskotka-obrys.webp";
const TEE_FRONT = "https://customer-assets-jt897jd0.emergentagent.net/job_smoke-beach-drop/artifacts/5vqndgmu_front-tee.png";
const TEE_BACK = "https://customer-assets-jt897jd0.emergentagent.net/job_smoke-beach-drop/artifacts/2o0hb98b_back-tee.png";
const PRINT_FULL = "https://customer-assets-jt897jd0.emergentagent.net/job_smoke-beach-drop/artifacts/5tm5ju00_back-tlo.webp";
const PRINT_FRONT = "https://customer-assets-jt897jd0.emergentagent.net/job_smoke-beach-drop/artifacts/1ses3z8i_front-tlo.webp";

const FRAMES = [
  { img: PRINT_FULL, label: "BACK PRINT — FULL GRAPHIC", blend: "mix-blend-screen", bg: "bg-[#141416]", span: "sm:col-span-2 sm:row-span-2", rot: "-rotate-[0.8deg]" },
  { img: TEE_FRONT, label: "FRONT — CHEST HIT", blend: "mix-blend-multiply", bg: "bg-[#e8dcc3] halftone", span: "", rot: "rotate-[1.2deg]" },
  { img: MASCOT, label: "THE SMUGGLER — MASCOT", blend: "", bg: "bg-[#d96b43] halftone", span: "", rot: "-rotate-[1.4deg]", contain: true },
  { img: TEE_BACK, label: "BACK — BIG PRINT", blend: "mix-blend-multiply", bg: "bg-[#e8dcc3] halftone", span: "", rot: "rotate-[0.9deg]" },
  { img: PRINT_FRONT, label: "$IGN UP! — FRONT LOGO", blend: "mix-blend-screen", bg: "bg-[#141416]", span: "sm:col-span-2", rot: "-rotate-[0.7deg]" },
];

export const Lookbook = ({ t }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [50, -50]);

  return (
    <section id="lookbook" ref={ref} data-testid="lookbook-section" className="border-y-[3px] border-[#0a0a0a] bg-[#e5b83b] py-20 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <motion.p className="font-mono2 text-[11px] font-bold tracking-[0.4em] text-[#0a0a0a]/60" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}>
              {t.lookbook.kicker}
            </motion.p>
            <motion.h2
              className="mt-3 font-script text-4xl text-[#0a0a0a] sm:text-6xl"
              initial={{ opacity: 0, y: 26, rotate: 2 }}
              whileInView={{ opacity: 1, y: 0, rotate: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, ease: [0.34, 1.56, 0.64, 1] }}
            >
              {t.lookbook.title}
            </motion.h2>
          </div>
        </div>

        <motion.div style={{ y }} className="mt-14 grid auto-rows-[240px] grid-cols-1 gap-6 sm:grid-cols-3 sm:auto-rows-[260px]">
          {FRAMES.map((f, i) => (
            <motion.figure
              key={f.label}
              data-testid={`lookbook-tile-${i}`}
              className={`toon-frame toon-card group relative overflow-hidden ${f.bg} ${f.span} ${f.rot}`}
              initial={{ opacity: 0, y: 46 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08, duration: 0.65, ease: [0.34, 1.56, 0.64, 1] }}
            >
              <img
                src={f.img}
                alt={f.label}
                className={`toon-frame-img h-full w-full ${f.contain ? "object-contain p-6" : "object-cover"} ${f.blend}`}
              />
              <figcaption className="toon-chip absolute bottom-4 left-4 bg-[#0a0a0a] px-3 py-1.5 font-mono2 text-[10px] font-bold tracking-[0.25em] text-[#e5b83b] opacity-0 transition-all duration-400 group-hover:opacity-100">
                {f.label}
              </figcaption>
            </motion.figure>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
